// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2Kx0p","row":"Node_row__29tVn","label":"Node_label__1Silz","footer":"Node_footer__1Kd6g"};